import { Stack } from '@mui/material';
import {
  SplineChartWithHeader as BaseSplineChartWithHeader,
  SplineChartWithHeaderProps,
} from '@features/campaigns/components/Summary/SplineChartWithHeader';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

export const SplineChartWithHeader = (props: SplineChartWithHeaderProps) => {
  return (
    <Stack
      border={1}
      borderColor={unifiedPlatformColorPalette.lightGrey300}
      borderRadius="4px"
      sx={{ p: '10px', height: '100%' }}
    >
      <BaseSplineChartWithHeader {...props} />
    </Stack>
  );
};
